import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800" }
const _hoisted_2 = { class: "relative flex items-start" }
const _hoisted_3 = { class: "flex items-center h-5" }
const _hoisted_4 = ["checked", "disabled"]
const _hoisted_5 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800" }
const _hoisted_6 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800" }
const _hoisted_7 = { class: "px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-600" }
const _hoisted_8 = { class: "px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-600" }
const _hoisted_9 = { class: "px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-600" }
const _hoisted_10 = { class: "px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-600" }
const _hoisted_11 = { class: "px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-600" }
const _hoisted_12 = { class: "px-6 py-4 whitespace-nowrap text-sm font-normal" }
const _hoisted_13 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-green-600",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 13l4 4L19 7"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            type: "checkbox",
            class: _normalizeClass(["h-4 w-4 rounded", _ctx.isValid
                 ? 'cursor-pointer focus:ring-indigo-500 text-indigo-600 border-gray-300'
                 : 'cursor-not-allowed focus:ring-gray-500 text-gray-600 border-gray-300 bg-gray-100']),
            checked: _ctx.item.selected,
            disabled: !_ctx.isValid,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onValidChange && _ctx.onValidChange(...args)))
          }, null, 10, _hoisted_4)
        ])
      ])
    ]),
    _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.item.clinic?.name), 1),
    _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.item.worker?.name), 1),
    _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.item.cabinet?.name), 1),
    _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.item.xRayEquipment?.name), 1),
    _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.item.xRayImage?.imageName), 1),
    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.item.count), 1),
    _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.formatedDate), 1),
    _createElementVNode("td", _hoisted_12, [
      (_ctx.isValid)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_15))
        : (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
    ])
  ]))
}